import module from 'module';
import $ from 'jquery';
import _ from 'lodash';
import {Subject} from 'rxjs/Subject'
import 'rxjs/add/operator/auditTime';

import './prints-details.style.less';
import templateUrl from './prints-details.template.html';
import {printParameterTranslation} from "constants/print";
import {DEFAULT_FONT_SIZE} from '../../service/print/print.service';

module.component('printsDetails', {
  templateUrl,
  bindings: {
    printParameters: '<',
    print: '<'
  },
  controller: function ($location, $timeout, $scope, printsCache, confirmation, http, notification,
                        printService, $route, productDefinitionService, command) {
    const that = this;
    that.backgroundFiles = [];
    that.removedLineIds = [];

    that.$onInit = () => {
      that.populateLinesSampleText();
      that.splitLinesByType();

      that.availableFields = [...new Set(that.variableLines.map(l => l.field))];

      $scope.print = that.print;
      if (that.print.backgroundFileIds) {
        that.backgroundFiles = that.print.backgroundFileIds.map(fileId => ({id: fileId}));
      }

      that.preview();
    };

    that.populateLinesSampleText = () => {
      that.print.lines = that.print.lines.map(l => ({
        ...l, sampleText: l.field
      }));
    }

    that.splitLinesByType = () => {
      const lines = Object.groupBy(that.print.lines, l => l.type);

      that.variableLines = lines['VARIABLE'] || [];
      that.staticLines = lines['STATIC'] || [];
      that.imageLines = lines['IMAGE'] || [];
    };

    if (that.productDefinitionId) {
      productDefinitionService.toPromise()
        .then(defs => defs.find(def => String(def.id) === String(that.productDefinitionId)))
        .then(def => that.productDefinitionName = def.productName);
    }

    that.getPrintName = () => {
      if (!that.print) {
        return "";
      }

      let text = that.print.name;
      if (that.productDefinitionName) {
        text += ` for ${that.productDefinitionName}`;
      }

      return text;
    };

    that.printHasParams = () => {
      if (!that.print.parameters) {
        return false;
      }

      return Object.values(that.print.parameters).length > 0;
    };

    that.translatePrintParam = param => {
      return param in printParameterTranslation ? printParameterTranslation[param] : `<${param}>`;
    };

    that.$postLink = () => {
      that.printForm.$setSubmitted();
    };

    const backgroundFiles = () => {
      return that.backgroundFiles ? that.backgroundFiles : [];
    };

    const onLoad = () => {
      //Since I couldn't find a way to check if given pdf was rendered (iframe.onLoad is not enough), the
      //500 ms seems to be enough for chrome to render given pdf.  Without this there is visible blinking
      //during previews switching.
      const pdfRenderingTimeout = 500;
      $timeout(() => {
        let p = $('.prints-details__iframe-preview');
        $('.prints-details__iframe-hidden').toggleClass('prints-details__iframe-preview').toggleClass('prints-details__iframe-hidden');
        p.toggleClass('prints-details__iframe-preview').toggleClass('prints-details__iframe-hidden');
        $('.prints-details__iframe-hidden').one('load', onLoad);
      }, pdfRenderingTimeout);
    };
    $('.prints-details__iframe-hidden').one('load', onLoad);


    //Wait 500ms for change event. After given timeout has passed the preview action is called.
    const changeSubject = new Subject();
    const changeSub = changeSubject
      .auditTime(500)
      .subscribe(() => that.preview());

    that.onChange = () => {
      changeSubject.next();
    };

    $scope.$watch('$ctrl.backgroundFiles', () => that.onChange());

    that.getAttr = (attr) => {
      if (that.print) {
        return _.find(that.print.attributes, {type: attr});
      }
      return undefined;
    };

    const preparePdf = doc => {
      //make new copy of lines
      const lines = _.map(doc.lines, l => {
        l.text = l.text || l.field || l.sampleText;
        return l;
      });

      if (that.getAttr('MULTILINE_Y_SPACING') !== undefined) {
        //for multiline printing generate duplicate lines for better preview experience
        const defaultLineCount = 10;
        let lineCount = parseInt(that.getAttr('MULTILINE_LINE_COUNT').value) || defaultLineCount;
        let yOffset = parseInt(that.getAttr('MULTILINE_Y_SPACING').value);
        for (let i = 0; i < lineCount; i++) {
          for (let line of doc.lines) {
            let copy = _.cloneDeep(line);
            copy.y = line.y + yOffset * i;
            lines.push(copy);
          }
        }
      }

      const backgroundCount = backgroundFiles().length;
      const pageHeight = doc.orientation === 'PORTRAIT' ? doc.longEdge : doc.shortEdge;
      const pageCount = Math.max(1, backgroundCount, ...lines.map(line => 1 + Math.floor(line.y / pageHeight)));

      doc.pages = _.range(pageCount).map(page => {
        const pageStartHeight = page * pageHeight;
        const pageEndHeight = (page + 1) * pageHeight;
        const currentPageLines = lines.filter(line => line.y >= pageStartHeight - line.fontSize && line.y <= pageEndHeight + line.fontSize)
          .map(line => ({
            ...line, y: line.y - pageStartHeight
          }));

        return {lines: currentPageLines};
      });
      return doc;
    };

    that.preview = () => {
      if (!that.print) {
        return;
      }

      let print = preparePdf(that.print);
      printService.printToContainer(print, {
        autoPrint: false,
        backgroundThumbnails: backgroundFiles().map(file => file.thumbnail),
        backgroundEnabled: true,
        container: $('.prints-details__iframe-hidden')
      }, (pdf) => {
        let pdfSize = pdf.internal.pageSize;
        let ratio = pdfSize.width / pdfSize.height;
        $('#pdfWrapper').css('padding-bottom', (`${100 / ratio}%`));
      });
    };

    that.cancel = () => {
      const goBack = () => $location.path('/admin/prints/');
      if (that.printForm.$dirty) {
        confirmation('Do you want to cancel? Canceling will discard all changes.', goBack);
      } else {
        goBack();
      }
    };

    that.removeLine = (line) => {
      if (line.id) {
        that.removedLineIds.push(line.id);
      }

      const idx = that.print.lines.indexOf(line);
      that.print.lines.splice(idx, 1);
    }

    that.removeVariableLine = (line) => {
      const idx = that.variableLines.indexOf(line);
      that.variableLines.splice(idx, 1);

      that.removeLine(line);
      that.onChange();
    };

    that.removeStaticLine = async (line) => {
      const idx = that.staticLines.indexOf(line);
      that.staticLines.splice(idx, 1);

      that.removeLine(line);
      that.onChange();
    };

    that.addVariableLine = (field) => {
      const newLine = {
        printId: that.print.id,
        type: 'VARIABLE',
        field: field,
        active: true,
        x: 1,
        y: 1,
        maxLength: 0,
        bold: false,
        fontSize: DEFAULT_FONT_SIZE,
        sampleText: field,
        /*
         there is already a line for the same field,
         so it has to be anything bigger than 1 so user can remove it
         */
        fieldRowNo: 1 + 1
      };

      that.variableLines.push(newLine); // ensures newly added entry is at the end, easy to find
      that.print.lines.push(newLine); // ensures it's rendered and ready for print update

      that.onChange();
    };

    that.addStaticLine = () => {
      const newLine = {
        printId: that.print.id,
        type: 'STATIC',
        active: true,
        x: 1,
        y: 1,
        maxLength: 0,
        bold: false,
        fontSize: DEFAULT_FONT_SIZE
      };
      that.staticLines.push(newLine);
      that.print.lines.push(newLine);

      that.onChange();
    };

    that.executeCommandPromise = async () => {
      if (that.print.id) {
        return command.execute('UpdatePrint', {
          print: that.print,
          removedLineIds: that.removedLineIds
        }).toPromise();
      } else {
        return command.execute('CreatePrint', {
          print: that.print
        }).toPromise();
      }
    };

    that.save = async () => {
      that.print.backgroundFileIds = backgroundFiles().map(file => file.id);

      const response = await that.executeCommandPromise();
      if (response.approvalRequired) {
        return;
      }

      printsCache.evict();
      $location.path('/admin/prints');
    };

    that.$onDestroy = () => {
      changeSub.unsubscribe();
    };
  }

});
